/**
 * WeekStatsBar — the 5-stat banner above the weekly timesheet table.
 * Pure presentational. Lifted out of TimesheetsView for size.
 */
import { formatDuration } from '../../utils/timeClockHelpers';

const Stat = ({ C, label, value, accent }) => (
  <div>
    <div style={{ fontSize: '1.4rem', fontWeight: 800, color: accent ? C.primary : C.text }}>
      {value}
    </div>
    <div style={{ fontSize: '0.72rem', color: C.subtext, textTransform: 'uppercase', letterSpacing: 0.4, marginTop: 2 }}>
      {label}
    </div>
  </div>
);

const WeekStatsBar = ({ C, stats }) => (
  <div
    data-testid="weekly-stats-banner"
    style={{
      background: C.surface, border: `1px solid ${C.border}`, borderRadius: 14,
      padding: '1rem 1.25rem', marginBottom: '1rem',
      display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.5rem',
    }}
  >
    <Stat C={C} label="Regular" value={formatDuration(stats.regularMin)} />
    <Stat C={C} label="Paid Time Off" value={formatDuration(stats.ptoMin)} />
    <Stat C={C} label="Total Paid Hours" value={formatDuration(stats.totalPaidMin)} accent />
    <Stat C={C} label="Worked Days" value={String(stats.workedDays)} />
    <Stat C={C} label="Unpaid time off" value={formatDuration(stats.unpaidMin)} />
  </div>
);

export default WeekStatsBar;
